import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchPayments = createAsyncThunk('payments/fetchPayments', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/payments');
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener pagos');
  }
});

export const fetchPaymentById = createAsyncThunk('payments/fetchPaymentById', async (id, { rejectWithValue }) => {
  try {
    const response = await api.get(`/payments/${id}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener pago');
  }
});

export const createPayment = createAsyncThunk('payments/createPayment', async (paymentData, { rejectWithValue }) => {
  try {
    const response = await api.post('/payments', paymentData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al crear pago');
  }
});

export const updatePayment = createAsyncThunk('payments/updatePayment', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await api.put(`/payments/${id}`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al actualizar pago');
  }
});

export const deletePayment = createAsyncThunk('payments/deletePayment', async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/payments/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al eliminar pago');
  }
});

export const payInstallment = createAsyncThunk('payments/payInstallment', async ({ paymentId, installmentId }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/payments/${paymentId}/installments/${installmentId}/pay`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al pagar cuota');
  }
});

export const fetchPaymentSummary = createAsyncThunk('payments/fetchPaymentSummary', async (id, { rejectWithValue }) => {
  try {
    const response = await api.get(`/payments/${id}/summary`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener resumen');
  }
});

const paymentsSlice = createSlice({
  name: 'payments',
  initialState: {
    payments: [],
    currentPayment: null,
    paymentSummary: null,
    lastCreatedExpense: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentPayment: (state) => {
      state.currentPayment = null;
      state.paymentSummary = null;
    },
    clearLastCreatedExpense: (state) => {
      state.lastCreatedExpense = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload;
      })
      .addCase(fetchPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPaymentById.fulfilled, (state, action) => {
        state.currentPayment = action.payload;
      })
      .addCase(createPayment.fulfilled, (state, action) => {
        state.payments.push(action.payload);
      })
      .addCase(updatePayment.fulfilled, (state, action) => {
        const index = state.payments.findIndex(p => p.id === action.payload.id);
        if (index !== -1) {
          state.payments[index] = action.payload;
        }
      })
      .addCase(deletePayment.fulfilled, (state, action) => {
        state.payments = state.payments.filter(p => p.id !== action.payload);
      })
      .addCase(fetchPaymentSummary.fulfilled, (state, action) => {
        state.paymentSummary = action.payload;
      })
      .addCase(payInstallment.fulfilled, (state, action) => {
        state.lastCreatedExpense = action.payload.expense_created;
      });
  },
});

export const { clearError, clearCurrentPayment, clearLastCreatedExpense } = paymentsSlice.actions;
export default paymentsSlice.reducer;
